import { DefaultLayout } from '@/layouts';
import { IDMSContainer } from '@/components/Analysis/Idms/IdmsContainer';

export const IDMSPage = () => {
  return (
    <DefaultLayout variant="analysis">
      <IDMSContainer />
    </DefaultLayout>
  );
};
